
import type React from "react"
import { useDraggable } from "@dnd-kit/core"
import { PipelineCard } from "./pipeline-card"
import type { ApiEstimate } from "@/lib/api/types"

interface DraggableCardProps {
  estimate: ApiEstimate
  isNew?: boolean
  isConsumerLead?: boolean
  isTotalLoss?: boolean
  disabled?: boolean
  onViewDetails?: (estimateId: string) => void
  onCall?: (phone: string) => void
  onEmail?: (email: string) => void
  onSMS?: (phone: string) => void
  onConfirm?: (estimateId: string) => void
  actionButton?: React.ReactNode
}

export function DraggableCard({ disabled, ...props }: DraggableCardProps) {
  const { listeners, setNodeRef, isDragging } = useDraggable({
    id: props.estimate.id,
    disabled,
  })

  // Read-only (dealership) cards are not drag surfaces at all — render plain.
  if (disabled) {
    return <PipelineCard {...props} />
  }

  // Pointer-drag surface only. We intentionally DON'T spread dnd-kit's
  // `attributes` (role="button" + tabIndex): they turned the card into a fake
  // button that (a) swallowed Enter and (b) nested the real Confirm/contact
  // buttons inside a button — invalid, and unreachable by keyboard. Keyboard &
  // touch users act via those inner buttons instead; drag stays a mouse/touch
  // enhancement layered on top. (a11y findings F11/F12)
  return (
    <div
      ref={setNodeRef}
      style={{ opacity: isDragging ? 0.3 : 1 }}
      {...listeners}
    >
      <PipelineCard {...props} />
    </div>
  )
}
